import { render } from "./aGender.vue?vue&type=template&id=7f855dfe"
import script from "./aGender.vue?vue&type=script&lang=js"
export * from "./aGender.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__